module.exports = __webpack_public_path__ + "static/media/Lyne_Johnson_Livre_de_ansiedade.72164908.jpg";